import VERT_DATA from "@/data/verticalsData.json";
import SVC_DATA from "@/data/servicePagesData.json";

/**
 * Maps a preview route (pathname) to its WordPress deploy target.
 * Used by the top bar to fold per-page deploy actions into the app chrome.
 */
const STATIC_MAP = {
  "/": { target: "homepage", label: "Homepage" },
  "/about": { target: "about", label: "About" },
  "/services": { target: "services", label: "Services" },
  "/insurance-marketing-machine": { target: "insurance", label: "Insurance Marketing Machine" },
  "/solution": { target: "solution", label: "Solution" },
  "/contact": { target: "contact", label: "Contact" },
  "/blog": { target: "blog", label: "Blog Hub" },
};

const ROUTE_MAP = { ...STATIC_MAP };
Object.entries(VERT_DATA.verticals).forEach(([k, v]) => {
  ROUTE_MAP[`/${v.slug}`] = { target: `vertical-${k}`, label: `${v.name} Marketing Machine` };
});
Object.keys(SVC_DATA.services).forEach((k) => {
  ROUTE_MAP[`/${k}`] = { target: `svc-${k}`, label: SVC_DATA.services[k].title || k };
});

const PAGE_NAMES = {
  "/deploy": "Deploy Engine",
  "/workspace": "Workspace Pages",
  "/preview": "Site Mockup",
  "/sync": "Data Sync",
  "/aa-pilot": "AA Pilot Demo",
  "/flatsome-export": "Flatsome Export",
  "/content-qa": "Content QA",
};

export const resolveRoute = (pathname) => {
  const clean = pathname.replace(/\/+$/, "") || "/";
  const mapped = ROUTE_MAP[clean];
  if (mapped) return { ...mapped, deployable: true };
  if (clean.startsWith("/blog/")) return { target: null, label: "Blog Post", deployable: false };
  return { target: null, label: PAGE_NAMES[clean] || clean, deployable: false };
};
